import { Link } from "react-router-dom";
import classes from "./OurServices.module.css";

const RenderColService = ({
  image,
  imageAlt,
  title,
  hook,
  deliverables,
  bestFor,
  reverse,
  href,
  width,
  height,
}) => (
  <article className={`${classes.service} ${reverse ? classes.reverse : ""}`}>
    <div className={classes.media}>
      <img
        src={image}
        alt={imageAlt}
        width={width}
        height={height}
        loading="lazy"
        decoding="async"
      />
    </div>
    <div className={classes.body}>
      <h3 className={classes.serviceTitle}>
        <Link to={href}>{title}</Link>
      </h3>
      <p className={classes.hook}>{hook}</p>
      <p className={classes.label}>What you get</p>
      <ul className={classes.deliverables}>
        {deliverables.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p className={classes.bestFor}>
        <span>Best for</span> {bestFor}
      </p>
      <Link className={classes.more} to={href}>
        Learn more about {title}
      </Link>
    </div>
  </article>
);

export default RenderColService;
